import PropTypes from 'prop-types';
import { Networks } from 'automation-ui-action-features/actions/ads-audience-membership/constants';
export const AudienceShape = PropTypes.shape({
  networkState: PropTypes.shape({
    name: PropTypes.string.isRequired
  }).isRequired,
  targetingAudience: PropTypes.shape({
    adNetwork: PropTypes.oneOf([Networks.ADWORDS, Networks.FACEBOOK, Networks.LINKEDIN]).isRequired,
    id: PropTypes.number.isRequired
  }).isRequired
});